import * as React from 'react';
import { Header } from './header';
import { Footer } from './footer';
import { Search } from './search';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { ZefixConfig } from './zefix-config';
import fetchMessages from '../util/fetch-messages';

export interface AppProps {
    title: string;
}

export interface AppState {
    tagsHighlighted: boolean;
    messages: Array<any>;
}

var parties = [
    {
        name: 'PartyA',
        shortName: 'A',
        color: '#fff100'
    },
    {
        name: 'PartyB',
        shortName: 'B',
        color: '#00bcf2'
    },
    {
        name: 'PartyC',
        shortName: 'C',
        // color: '#BAD80A'
        color: '#a6a6a6'
    }
]


export class App extends React.Component<AppProps, AppState> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tagsHighlighted: false,
            messages: []
        };
    }

    componentWillMount() {
      fetchMessages()
        .then((messages) => {
          if (!messages) return;
          this.setState({ messages });
        })
    }

    componentDidMount() {
        this.loadConfig();
        Office.context.document.settings.refreshAsync(async () => {
            this.setState({
                tagsHighlighted: Office.context.document.settings.get('tagsHighlighted')
            }, () => {
                this.syncTagHiglights();
            })
        })
    }

    loadConfig = async () => {
        ZefixConfig.loadLocalConfig();
    }

    syncTagHiglights = async () => {
        if(this.state.tagsHighlighted) {
            await this.highlightAllTags()
        } else {
            await this.unhighlightAllTags()
        }
    }

    toggleTagHighlight = async () => {
        await this.setState({
            tagsHighlighted: !this.state.tagsHighlighted
        }, async () => {
            Office.context.document.settings.set('tagsHighlighted', this.state.tagsHighlighted);
            await Office.context.document.settings.saveAsync();
            this.syncTagHiglights();
        })
    }

    highlightAllTags = async () => {
        await Word.run(async (context) => {
            var contentControls = context.document.contentControls;
            context.load(contentControls, 'id, text, tag, title');
            await context.sync();
            for (let contentControl of contentControls.items) {
                if (contentControl.tag.startsWith('lexsearch_zefix_p') ) {
                    contentControl.font.highlightColor = parties[Number(contentControl.tag.charAt(17))].color;
                }
            }
            await context.sync();
        });
    }

    unhighlightAllTags = async () => {
        await Word.run(async (context) => {
            var contentControls = context.document.contentControls;
            context.load(contentControls, 'id, text, tag, title');
            await context.sync();
            for (let contentControl of contentControls.items) {
                if (contentControl.tag.startsWith('lexsearch_zefix_p') ) {
                    contentControl.font.highlightColor = null;
                }
            }
            await context.sync();
        });
    }

    transformTags = async () => {
        await Word.run(async (context) => {
            for (var partyIndex = 0; partyIndex < parties.length; ++partyIndex) {
                let party = parties[partyIndex];
                for (let attributeName of ['name', 'address', 'uid']) {
                    var results = context.document.body.search(`Party${party.shortName}_${attributeName}`);
                    context.load(results);
                    await context.sync();
                    for (var i = 0; i < results.items.length; i++) {
                        var cc = results.items[i].insertContentControl();
                        cc.tag = `lexsearch_zefix_p${partyIndex}${attributeName}`;
                        cc.title = `${party.shortName}: ${attributeName}`;
                        cc.appearance = "hidden";
                        cc.placeholderText = cc.title;
                        results.items[i].insertText("", Word.InsertLocation.replace);
                    }
                }
            }
            await context.sync();
            await this.syncTagHiglights();
        });

    }
    render() {
        return (
            <div className='ms-welcome'>
                { this.state.messages.map((message) => {
                  return (
                    <div style={{ backgroundColor: '#f4f4f4'}} key={message.id}>
                    <MessageBar isMultiline={ true } messageBarType={ MessageBarType.warning } onDismiss={ () => {
                      Office.context.document.settings.set('message_read_' + message.id, true);
                      Office.context.document.settings.saveAsync(() => { /* noop */ })

                      this.setState({ messages: this.state.messages.filter((msg) => msg.id !== message.id) })
                    } }>
                      <span dangerouslySetInnerHTML={{ __html: message.html }}></span>
                    </MessageBar>
                    <br />
                    </div>
                  )
                })}
                <Header />
                <Search />
                <Footer tagsHighlighted={this.state.tagsHighlighted} onToggleTagHighlighting={this.toggleTagHighlight} onTransformTags={this.transformTags} />
            </div>
        );
    };


};



// WEBPACK FOOTER //
// ./components/app.tsx